import {
    assoc,
    omit
} from 'ramda';

const checkErrors = (label, value, errors, validator) => {
    const error = validator.validateValue(label, value);
    if (!error) return omit([label], errors);

    return assoc(label, error, errors);
};

export default checkErrors;
